import PersonalCustomerVerificationButton from "./PersonalCustomerVerificationButton"

export default PersonalCustomerVerificationButton
